import React, { type FC } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import type { ExternalCollaboratorsSpaceInformationMessageProps } from './ExternalCollaboratorsSpaceInformationMessage.tsx';
import { ExternalCollaboratorsSpaceInformationMessage } from './ExternalCollaboratorsSpaceInformationMessage.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	backgroundColor: token('color.background.accent.gray.subtlest'),
	padding: `${token('space.300')}`,
});

export const ExternalCollaboratorsSpaceInformationMessageFooter: FC<
	ExternalCollaboratorsSpaceInformationMessageProps
> = (props) => (
	<Wrapper>
		<ExternalCollaboratorsSpaceInformationMessage {...props} />
	</Wrapper>
);
